import React, { useEffect, useRef, useState } from 'react'
import './legal-approval-modal.styles.scss'
import { useDispatch, useSelector } from 'react-redux'
import { UseCloudFunction } from '@/utils/firebase.utils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Modal, { ModalAlert } from '@/components/modal/modal.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { setUserProfile } from '@/state/slices/userSlice';

const LegalApprovalModal = ({ playerData }) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const membership = useSelector(state => state.userData.membership);
  const [show, setShow] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const profileRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (!userProfile) return;
    if (!userProfile.legalApproved) {
      if (location.pathname.includes('/play/')) {
        if (!playerData) return;
        if (userProfile.upload) {
          profileRef.current = { ...userProfile };
          profileRef.current.gameId = playerData.gameId;
          profileRef.current.playerId = playerData.playerId;
        } else {
          profileRef.current = { ...userProfile };
        }
      } else {
        profileRef.current = { ...userProfile };
      }
      setShow(true);
    }
  }, [userProfile, playerData])

  async function approveLegal() {
    if (location.pathname.includes('/preview/manager/')) {
        setAlertMessage('Sorry! Data cannot be saved in Preview Mode.');
        return;
      }
    setLoading(true);
    let res;
    res = await UseCloudFunction(
      'approveLegal',
      {
        appId: profileRef.current.appId,
        userProfile: profileRef.current
      }
    )
    console.log(res);
    if (res.error) {
      setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
      setLoading(false);
      trackException(`Legal Approval Error: ${res.error}`);
      return;
    }
    let ts = res.ts;
    const newProfile = {
      ...userProfile,
      ...{ 'legalApproved': ts }
    }
    dispatch(setUserProfile(newProfile));
    setLoading(false);
    setShow(false);
    trackEvent(
      'legal_approved',
      'User',
      `User ${userProfile
        ? userProfile.appId
        : 'Guest'
      } approved the legal terms.`,
      null,
      membership
    )
  }

  return (
    <div className='legal-approval-modal'>
      <Modal
        show={show}
        cancel={() => setShow(false)}
        text='Agree to Terms of Service and Privacy Policy'
        cls='narrow'>
        <div>
          By clicking 'Accept' below, you acknowledge that you have read and understand our <a
            href="/terms" target="_blank">Terms of Service</a> and our <a
              href="/privacy" target="_blank">Privacy Policy</a>, and you agree to be
          bound by them.
          <div className="g-space-1"></div>
          {
            (loading)
              ?
              <div className='buttons'>
                <button className='g-button disabled'>Decline</button>
                <button className='g-button disabled'><ThreeDotsLoader /></button>
              </div>
              :
              <div className='buttons'>
                <button
                  className='g-button'
                  onClick={() => navigate('/logout')}>
                  Decline
                </button>
                <button
                  className='g-button primary'
                  onClick={() => approveLegal()}>
                  Accept
                </button>
              </div>
          }
        </div>
      </Modal>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
    </div>
  )
}

export default LegalApprovalModal